'use client';

import {useEffect, useRef} from 'react';
import clsx from 'clsx';

import {ContentBlockContainer} from '@/components/content-blocks/block-container';
import type {ExtractContentBlockType} from '@/components/content-blocks/ContentBlocks';

type Props = ExtractContentBlockType<'cookieList'>;

export const CookieList = ({contentBlockOptions}: Props) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = `//report.cookie-script.com/r/f65ba4da65f8a65e03fd09323f3d86e3.js`;
			script.setAttribute('data-cookiescriptreport', 'report');
			containerRef.current.appendChild(script);
		}
	}, []);

	return (
		<ContentBlockContainer options={contentBlockOptions} width="text">
			<div
				ref={containerRef}
				className={clsx(
					'[&_h4]:font-display',
					'[&_h4]:font-bold',
					'[&_h4]:text-2xl',
					'[&_h4]:md:text-heading-md',
					'[&_h4]:leading-tight',
					'[&_h4]:mb-4',
					'[&_table]:mb-8',
					'[&_h4]:scroll-m-14',
					'overflow-x-auto',
				)}
			/>
		</ContentBlockContainer>
	);
};
